module.exports = __webpack_public_path__ + "static/video-ea82776f5b2325b9e64e62dcb881c0ef.mp4";